/*
 * Copyright 2019 LABOR.digital
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Last modified: 2019.07.25 at 14:28
 */
import { isNumber } from './isNumber';
import { isString } from './isString';
/**
 * Returns true if the given value seems to be numeric. Either a number or a string, representing a number
 * @param v
 */
export function isNumeric(v) {
    return isNumber(v) || isString(v) && (!isNaN(parseInt(v)) || !isNaN(parseFloat(v)));
}
//# sourceMappingURL=isNumeric.js.map